import { useAuth } from "../hooks";
import { useCurrentTalentProfile } from "../hooks";
import UserRoutes from "./UserRoutes";
import TalentRoutes from "./TalentRoutes";
import GuestRoutes from "./GuestRoutes";
import React from "react";
import ScreenLoader from "../components/Loader/ScreenLoader";

/**
 * App routing: guest, talent, and user only.
 */
export default function AppRouter(): JSX.Element | null {
  const { userInfo, accessToken, authBootstrapping } = useAuth();
  const { currentProfile } = useCurrentTalentProfile();

  if (authBootstrapping) {
    return <ScreenLoader />;
  }

  const isAuthenticated = !!accessToken && !!userInfo;

  if (!isAuthenticated) {
    return <GuestRoutes />;
  }

  if (currentProfile) {
    return <TalentRoutes />;
  }

  return <UserRoutes />;
}
